import { render, staticRenderFns } from "./traineePostassessmentReport.vue?vue&type=template&id=fa93d4f0&scoped=true"
import script from "./traineePostassessmentReport.vue?vue&type=script&lang=js"
export * from "./traineePostassessmentReport.vue?vue&type=script&lang=js"
import style0 from "./traineePostassessmentReport.vue?vue&type=style&index=0&id=fa93d4f0&prod&scoped=true&lang=css"
import style1 from "./traineePostassessmentReport.vue?vue&type=style&index=1&id=fa93d4f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa93d4f0",
  null
  
)

export default component.exports